import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import ActionBarItemContentWrapper from '../ActionBarItemContentWrapper';
import s from './ActionBarButton.scss';
/**
 * A button for our `ActionBar`.
 */ const ActionBarButton = (_param)=>{
    var { className, dataHook, children } = _param, rest = _object_without_properties(_param, [
        "className",
        "dataHook",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: c(s['root'], className),
        "data-hook": dataHook
    }, rest), /*#__PURE__*/ React.createElement(ActionBarItemContentWrapper, null, children));
};
ActionBarButton.displayName = 'ActionBarButton';
export default ActionBarButton;
